import { render, staticRenderFns } from "./cardloading.vue?vue&type=template&id=36b9518c&scoped=true&"
import script from "./cardloading.vue?vue&type=script&lang=js&"
export * from "./cardloading.vue?vue&type=script&lang=js&"
import style0 from "./cardloading.vue?vue&type=style&index=0&id=36b9518c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b9518c",
  null
  
)

export default component.exports